export const stylesConst = {
  primaryColor: '#000',
  primaryRed: '#fc0004',
  primaryBlack: '#121212',
  yellow: '#e2be00',
  green: '#48a300',
  gray: '#e2e2e2',
  grayDark: '#f1f1f1',
  dark: '#888888',
  textGray: '#6b6b6b',
}